import router from './router'
import Index from '@/view/index.vue'
import Cookies from 'js-cookie'
import store from './vuex/store';
import default_pages from './router/default'
import Vue from 'vue'
router.beforeEach((to, from, next) => {

  const token = Cookies.get('admin-token_wm');
  let page = '';
  const path = to.path;
  console.log(to.path)
  if (to.path == '/') {
    page = 'index';
  }
  else {
    page = to.path.replace('/', '');
  }
  store.state.app.now_page = page;

  //生成模板号,有个bug，可视化窗口存在，后台切换模板，保存的时候就会把数据带给新、
  if(store.state.app.theme_id == ''){
    store.state.app.theme_id = Cookies.get('admin_theme_id_wm');
  }
  if(store.state.app.admin_token == ''){
    store.state.app.admin_token = Cookies.get('admin_token_wm');
  }

  //跳转页面后，会重复绑定事件，所以先清除一次
  $(window).unbind();
  $(document).unbind();

  //根据后台返回的页面列表，动态生产路由，如果请求失败，根据默认路由生成
  if (store.state.app.pages.length == 0) {
    store.dispatch('app/get_pags').then((data) => {
      let pages = [];
      data.map((item) => {
        const one = {
          path: '/' + item.name,
          name: item.name,
          component: Index,
          alias: '',
          meta: {
            title: item.title
          }
        }
        pages.push(one);
      });
      router.addRoutes(pages);
      next({ ...to, replace: true })

    }).catch((err) => {
      //失败的时候，用定义好的路由拼接，保证能使用
      router.addRoutes(default_pages);
      next({ ...to, replace: true })
    })
  }
  else {
    next()
  }
})

router.afterEach((to, from) => {

  
})




// WEBPACK FOOTER //
// ./src/permission.js